import React from "react"

function PrivateCard({ fontSize = 25 }) {
  return <i role="button" className="fa fa-lock " style={{ color: "#ff0000", fontSize, position: 'absolute', left: 10, top: 5 }} />
}

export default PrivateCard
